package com.bikompanion.data.analytics.web

import com.bikompanion.domain.analytics.AnalyticsEvent

/**
 * One captured event, with the session, page and time as they were when it happened.
 *
 * Events are sent in batches, so resolving these at send time would attribute an event to
 * whatever session or screen the flush happened to land in.
 */
internal data class WebAnalyticsRecord(
    val event: AnalyticsEvent,
    val context: WebAnalyticsContext,
    val timestampMicros: Long,
    val pageParameters: Map<String, String> = emptyMap(),
)
